import styled from 'styled-components';
import colors from 'Styles/colors';
import CancelButton from 'shared/ui/CancelButton';

export const Wrapper = styled.div`
  margin-top: 19px;
  background-color: ${({ theme }) => theme.backgrounds.tagsInAgentsDetail};
  padding: 27px 21px;
  border-radius: 4px;
  box-shadow: 0 2px 50px 0 rgba(0, 0, 0, 0.1);

`;
Wrapper.displayName = 'Wrapper';

export const Title = styled.div`
  user-select: none;
  font-size: 17px;
  font-weight: 600;
  color: ${({ theme }) => theme.text.tableAssetItem};
  margin-bottom: 17px;
`;
Title.displayName = 'Title';

export const EntityTitle = styled.div`
  user-select: none;
  font-size: 12.5px;
  font-weight: 600;
  color: ${({ theme }) => theme.text.tableAssetItem};
  text-transform: capitalize;
`;
EntityTitle.displayName = 'EntityTitle';

export const Input = styled.input`
  height: 34px;
  padding: 9px 9px 7px 10px;
  box-shadow: ${({ theme }) => `inset 0 -1px 0 0 ${theme.shadows.tagsInputAgent}`};
  background-color: ${({ theme }) => theme.backgrounds.runAgentInput};
  color: ${({ theme }) => theme.text.runAgentInput};
  border: 0;
  width: 100%;
  margin-right: 20px;
  
  &::placeholder {
    font-size: 14.5px;
    color: ${colors.grey17};
  }
`;
Input.displayName = 'Input';

export const Entities = styled.div`
  display: flex;
  flex-direction: column;
`;
Entities.displayName = 'Entities';

export const TagsWrapper = styled.div`
  display:flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: 8px;
`;

export const TagContainer = styled.div`
  cursor: default;
  display:flex;
  flex-direction: row;
  align-items: center;
  height: 24px;
  padding: 5px 7px 5.5px 7px;
  margin: 5px 10px 0 0;
  background-color: ${({ theme }) => theme.backgrounds.attributeTag};
  border: ${({ theme }) => `solid 1px ${theme.borders.attributeTag}`};
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.06);
  border-radius: 2px;
`;

export const TagLabel = styled.div`
  text-align: left;
  font-size: 11.5px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${({ theme }) => theme.text.attributeTag};
  white-space: nowrap;
`;

export const NoDataText = styled.div`
  font-size: 11.5px;
  font-weight: 400;
  color: ${colors.grey19};
`;
NoDataText.displayName = 'NoDataText';

export const Edit = styled(CancelButton)`
  margin: 15px 0;
`;
Edit.displayName = 'Edit';
